'use es6';

import { createContext } from 'react';
import { OLAF, BATTLESHIP, OBSIDIAN, EERIE } from 'HubStyleTokens/colors';
import { AGENT, DEFAULT, VISITOR } from 'conversations-message-history/constants/messageUses';
import Theme from 'conversations-message-history/primary-message/records/Theme';
export const defaultThemeConfig = {
  [DEFAULT]: Theme(),
  [AGENT]: Theme({
    backgroundColor: OLAF,
    borderColor: BATTLESHIP,
    headerBackgroundColor: OLAF,
    headerTextColor: OBSIDIAN,
    avatarBackgroundColor: BATTLESHIP,
    avatarBorderColor: BATTLESHIP,
    avatarTextColor: OBSIDIAN
  }),
  [VISITOR]: Theme({
    backgroundColor: OLAF,
    borderColor: BATTLESHIP,
    headerBackgroundColor: EERIE,
    headerTextColor: OLAF,
    avatarBackgroundColor: EERIE,
    avatarTextColor: OLAF
  })
};

/**
 * Uses a configuration file (or the default) containing a mapping of message uses to their
 * respective themes. Since a theme record sets values for every field by default, consumers of a
 * theme will always have a value to choose from.
 */
const ThemeConfigContext = /*#__PURE__*/createContext(defaultThemeConfig);
export default ThemeConfigContext;